import {
  WAF_STATUS,
  type WafStatusForDomain,
} from '../domain-manager/waf-status';

type DomainWithWaf = {
  hasWaf?: boolean | null;
};

export const getHasWafFromWafStatus = (
  status: WafStatusForDomain,
): boolean | null => {
  if (status === WAF_STATUS.wafDetected) return true;
  if (status === WAF_STATUS.noWaf || status === WAF_STATUS.untrustedCertificate)
    return false;

  return null;
};

export const applyWafStatusesToDomains = <TDomain extends DomainWithWaf>({
  domains,
  statuses,
}: {
  domains: TDomain[];
  statuses: WafStatusForDomain[];
}): TDomain[] | null => {
  const nextDomains = domains.map((domain, index) => {
    const resolvedHasWaf = getHasWafFromWafStatus(
      statuses[index] ?? WAF_STATUS.idle,
    );

    if (resolvedHasWaf === null || domain.hasWaf === resolvedHasWaf) {
      return domain;
    }

    return { ...domain, hasWaf: resolvedHasWaf };
  });

  return nextDomains.some((domain, index) => domain !== domains[index])
    ? nextDomains
    : null;
};
